var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.result},[_c('span',[_vm._t("default")],2),_c('SustainabilityClassification',{attrs:{"value":_vm.result && _vm.result.detailedClassification}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }